const mergeCredentialOverlay = (credential, { secretsOverlay, metaOverlay }) => {
  if (!credential) {
    return credential;
  }

  const hasSecretsOverlay = secretsOverlay && typeof secretsOverlay === 'object';
  const hasMetaOverlay = metaOverlay && typeof metaOverlay === 'object';

  if (!hasSecretsOverlay && !hasMetaOverlay) {
    return credential;
  }

  return {
    ...credential,
    secrets: hasSecretsOverlay ? { ...(credential.secrets || {}), ...secretsOverlay } : credential.secrets,
    meta: hasMetaOverlay ? { ...(credential.meta || {}), ...metaOverlay } : credential.meta
  };
};

export default mergeCredentialOverlay;
